// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50a83da2","455":"d650d3f5","977":"8789d3a9"}[chunkId] + ".chunk.js";
};